import * as React from "react";
import { cn } from "@/lib/utils";

export const panelClass =
  "rounded-3xl bg-black/70 ring-1 ring-[#7b2ee6]/60 backdrop-blur-md";


interface ModalPanelProps {
  className?: string;
  children: React.ReactNode;
}

export function ModalPanel({ className, children }: ModalPanelProps) {
  return (
    <div className={cn("p-5", panelClass, className)}>
      {children}
    </div>
  );
}
